import logger from '../services/logging/logging-service';

/**
 * Check if an Object is Empty
 * @param {object} obj object name
 */
export const isEmptyObject = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};

/**
 * Print out Object
 * @param {object} obj object name
 */
export const printObject = (obj) => {
  const objectString = JSON.stringify(obj, null, 4);
  logger.info(`The ${typeof obj} is: ${objectString}`);
  return objectString;
};

export const flatObjectToArray = (flatObject) => Object.values(flatObject);
